import ChooseBrokerContainer from "containers/jarivsPrime/ChooseBroker";
import React from "react";

const PrimeChooseBroker = (props) => {
  return (
    <>
      <ChooseBrokerContainer />
    </>
  );
};

export default PrimeChooseBroker;
